module.exports = __webpack_public_path__ + "img/autohuh-original-1920.04d59cd1.png";